import { addDocumentType, removeDocumentType, updateDocumentType } from './documentTypeAction'
import { Constants } from './documentTypeConstants'
import { MokaiDocumentType } from '../../../model/dossier.model'


type Actions =
    | ReturnType<typeof addDocumentType>
    | ReturnType<typeof removeDocumentType>
    | ReturnType<typeof updateDocumentType>


export function documentTypeReducer(
    state: MokaiDocumentType[] = [],
    action: Actions) {

    switch (action.type) {
        case Constants.ADD_DOCUMENT_TYPE:
            return [...state, action.payload]

        case Constants.UPDATE_DOCUMENT_TYPE:
            return state.map((documentType: MokaiDocumentType) => {
                if (documentType.document_type_id !== action.payload.document_type_id) {
                    return documentType
                }
                return {
                    ...documentType,
                    ...action.payload
                }
            })

        case Constants.REMOVE_DOCUMENT_TYPE:
            return state.filter((documentType: MokaiDocumentType) => 
                documentType.document_type_id !== action.payload
            )
        default:
            return state
    }

}